import React from 'react';
import ItemIcon from './ItemIcon';
import '../../styles/item/ItemMarketTile.css';
import {centsToString} from 'util/cashFormatter';
import itemTypeToEmoji from 'util/itemTypeToEmoji';
import {useSessionConfiguration} from 'util/SessionConfigurationContext';

const ItemMarketTile = ({
                            handleItemClick,
                            config,
                            item
                        }) => {
    const {isDesktopView} = useSessionConfiguration();

    return (
        <div key={item.itemType} className={`list-item-container ${isDesktopView ? '' : 'mobile'}`}>
            <div>
                <div className="cursor-pointer" onClick={() => handleItemClick(item)}>
                    <ItemIcon lootItem={item.itemType} textSize={isDesktopView ? 4 : 2.8}/>
                </div>

                {config.map((conf, index) => {
                    let content;
                    switch (conf) {
                        case 'AllItems':
                            content = `Total: ${item.getMarketQuantity()}`;
                            break;
                        case 'MyItems':
                            content = `Owned: ${item.getUserQuantity()}`;
                            break;
                        case 'AllSellOffers':
                            content = item.getMarketSo()
                                ? `Price: ${centsToString(item.getMarketSo())}`
                                : 'Price: –';
                            break;
                        case 'AllBuyOffers':
                            content = item.getMarketBo()
                                ? `Demanded for: ${centsToString(item.getMarketBo())}`
                                : 'Demanded for: –';
                            break;
                        case 'Alphabet':
                            content = (
                                <span style={{
                                    fontSize: isDesktopView ? '0.8em' : '0.6em',
                                    fontWeight: 'bold',
                                    textAlign: 'center',
                                    display: 'block'
                                }}>
                                    {itemTypeToEmoji[item.itemType].translation.toUpperCase()}
                                </span>
                            );
                            break;
                        default:
                            content = conf;
                    }
                    return (
                        <div key={index} style={{fontSize: isDesktopView ? '1em' : '0.8em'}}>
                            {content}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ItemMarketTile;